import { useEffect, useState } from "react";
import "./LeaderVerifiedTrades.css";
import useApi from "../../../helpers/apiHelper/requestHelper";
import dropdownAngle from "../../../assets/images/dropdownAngle.svg";
import plusIcon from "../../../assets/images/plusIcon.svg";
import noDataIcon from "../../../assets/images/noDataIcon.svg";
import { useParams } from "react-router-dom";
import DisplayModalForTrader from "./DisplayModal";
import DisplayModalForCommunity from "../../PublicVerifiedTrade/viewSearchVerifiedTrade/DisplayModal";
import TablePagination from "../../sharedPages/CommonComponents/NewPagination/NewPagination";
import dayjs from "dayjs";
import ExactDateSelector from "../../sharedPages/CommonComponents/ExactDateSelector/ExactDateSelector.jsx";

const ITEMS_PER_PAGE = 10;

const LeaderVerifedTrades = () => {
  const [selectedDropdownId, setSelectedDropdownId] = useState(null);
  const [isCommunity, setIsCommunity] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [trades, setTrades] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);

  const api = useApi();
  const { id, name } = useParams();

  // Check if current dropdown is opened
  const isOpen = (id) => selectedDropdownId === id;

  const handleSelectedDropdown = (id) => {
    setSelectedDropdownId((preId) => (preId !== id ? id : null));
  };

  const columns = [
    "Date",
    "Time",
    "Asset",
    "Direction",
    "Blockchain Transaction ID",
    "Blockchain Link",
  ];

  const getVerifiedTrades = () => {
    api("get", `/blockchain/byCommunityOrTraderName/${name}`).then((res) => {
      if (res?.status) {
        console.log("res?.data?.records", res?.data?.records);
        setTrades(res?.data?.records.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        setIsCommunity(res?.data?.userHaveCommunity);
        setCurrentPage(1);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getVerifiedTrades();
  }, [id]);

  function formatBackendDate(isoString) {
    const date = new Date(isoString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  }

  function formatTimeWithUTCOffset(isoString) {
    const date = new Date(isoString);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const timezoneOffsetMinutes = -date.getTimezoneOffset();
    const timezoneOffsetHours = timezoneOffsetMinutes / 60;
    const sign = timezoneOffsetHours >= 0 ? "+" : "-";
    return `${hours}:${minutes}:${seconds} UTC${sign}${Math.abs(timezoneOffsetHours)}`;
  }

  // Helper function to get direction text
  const getDirectionText = (orderType) => {
    console.log("orderType", orderType);
    if (!orderType) return "N/A";
    switch (orderType.toUpperCase()) {
      case "LONG":
        return "LONG";
      case "SHORT":
        return "SHORT";
      default:
        return orderType;
    }
  };

  // Pagination helpers
  const filteredTrades = trades?.filter((trade) => {
    if (!selectedDate) return true;
    return dayjs(trade.createdAt).isSame(selectedDate, "day");
  });

  const totalPages = Math.ceil((filteredTrades?.length || 0) / ITEMS_PER_PAGE);
  const paginatedTrades = filteredTrades
    ? filteredTrades.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
      )
    : [];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSelectedDropdownId(null); // close any open dropdowns on page change
  };

  if (loading) {
    return (
      <div className="loadingWrapper">
        <div className="loading-4">
          <span className="span1"></span>
          <span className="span2"></span>
          <span className="span3"></span>
        </div>
      </div>
    );
  }

  return (
    <div className="custom-container">
      <div className="row align-items-center mb-d mt-d">
        <div className="col-sm-6 col-12">
        </div>
        <div className="col-sm-6 col-12">
          <div className="verifiedLinkSearchBox d-flex justify-content-end mb-0">
            <ExactDateSelector
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              maxDate={dayjs()}
            />
          </div>
        </div>
      </div>
      <div
        className={`leaderVerifyBlockchainTradesDetailPage ${
          !trades?.length && !loading && "verifyTradesDetailPageNoData"
        }`}
      >
        <div className="verifyBlockchainTradesWrapper">
          {/* Desktop View */}
          <div style={{position:"relative"}} className=" d-md-block d-none">
            <div className="publicVerifiedTradesTableWrap">
            <table className="publicVerifiedTradesTable">
              <thead>
                <tr>
                  <th></th>
                  <th>{isCommunity ? "Community" : "Trader"}</th>
                  {columns.map((col, i) => (
                    <th key={col} style={{ whiteSpace: "nowrap" }}>
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!trades?.length && !loading && (
                  <tr>
                    <td colSpan="8">
                      <div className="noDataTable">
                        <img src={noDataIcon} alt="noDataIcon" />
                        <h3 className="text-center">No verified trades yet</h3>
                      </div>
                    </td>
                  </tr>
                )}
                {paginatedTrades?.map((trade) => (
                  <tr key={trade._id}>
                    <td>
                      {trade?.statsSnapshot?.orders?.length > 1 && (
                        <div className="totalNumOfTrades">
                          <img alt="plusIcon" src={plusIcon} />
                          {trade.statsSnapshot.orders.length}
                        </div>
                      )}
                    </td>
                    <td
                      style={{ width: "180px" }}
                      className="tradeStatsSnapshot"
                      onClick={() => {
                        setSelectedTrade(trade);
                        setShow(true);
                      }}
                    >
                      {trade.statsSnapshot?.name?.split("_")[0]}
                    </td>
                    <td style={{ width: "90px" }}>
                      {formatBackendDate(trade.createdAt)}
                      {isOpen(trade._id) && (
                        <div className="tableDropdownContent">
                          {trade?.statsSnapshot?.orders?.map((option, index) => (
                            <p className="table-dropdown-option position-relative" key={index}>
                              {formatBackendDate(trade.createdAt)}
                            </p>
                          ))}
                        </div>
                      )}
                    </td>
                    <td style={{ width: "150px" }}>
                      {formatTimeWithUTCOffset(trade.createdAt)}
                      {isOpen(trade._id) && (
                        <div className="tableDropdownContent">
                          {trade.statsSnapshot?.orders?.map((option, index) => (
                            <p className="table-dropdown-option position-relative" key={index}>
                              {formatTimeWithUTCOffset(trade.createdAt)}
                            </p>
                          ))}
                        </div>
                      )}
                    </td>
                    <td style={{ width: "150px" }}>
                      <div
                        className="assertColumn"
                        onClick={() => {
                          if (trade.statsSnapshot?.orders?.length > 1) {
                            handleSelectedDropdown(trade._id);
                          }
                        }}
                      >
                        <button
                          className={`tableDropdownButton`}
                          style={{ marginBottom: isOpen(trade._id) ? 0 : 5 }}
                        >
                          <span className={`selectedOption `}>
                            {
                              trade?.statsSnapshot?.orders?.length > 1
                                ? "Multiple Trades"
                                : trade?.statsSnapshot?.orders?.length === 1
                                  ? (
                                    trade?.statsSnapshot?.orders[0]?.coinName?.includes("/")
                                      ? trade?.statsSnapshot?.orders[0]?.coinName
                                      : trade?.statsSnapshot?.orders[0]?.coinName?.replace(/(USDT|BUSD|USDC)$/, "/$1")
                                  )
                                  : trade?.type
                            }
                          </span>
                          <span
                            className={`dropdownArrow ${isOpen(trade._id) && "rotate"}`}
                            style={{ opacity: 1 }}
                          >
                            {trade.statsSnapshot?.orders?.length > 1 && (
                              <img alt="dropdownAngle" src={dropdownAngle} />
                            )}
                          </span>
                        </button>
                        {!isOpen(trade._id) && trade.statsSnapshot?.orders?.length > 1 && (
                          <span className={`clickForSelectText `}>CLICK TO SEE TRADES</span>
                        )}
                        {isOpen(trade._id) && (
                          <div className="tableDropdownContent">
                            {trade.statsSnapshot?.orders?.map((option, index) => (
                              <p className="table-dropdown-option position-relative" key={index}>
                                {option.coinName?.includes("/")?option.coinName:option.coinName?.replace(/(USDT|BUSD|USDC)$/, "/$1")}
                              </p>
                            ))}
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={{ width: "100px", textAlign: "center" }}>
                      {trade?.statsSnapshot?.orders?.length > 1 ? (
                        <div style={{textAlign:"start",fontSize:"12px"}}>
                          <span style={{textAlign:"start",fontSize:"12px"}}>Multiple</span>
                          {isOpen(trade._id) && (
                            <div className="tableDropdownContent" style={{textAlign:"start",fontSize:"12px"}}>
                              {trade.statsSnapshot?.orders?.map((option, index) => (
                                <p className="table-dropdown-option position-relative"  key={index}>
                                  {getDirectionText(option.side)}
                                </p>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : trade?.statsSnapshot?.orders?.length === 1 ? (
                        <div style={{textAlign:"start",fontSize:"12px"}}>
                          <span style={{textAlign:"start",fontSize:"12px"}}>{getDirectionText(trade.statsSnapshot?.orders[0]?.side)}</span>
                          {isOpen(trade._id) && (
                            <div className="tableDropdownContent">
                              {trade.statsSnapshot?.orders?.map((option, index) => (
                                <p className="table-dropdown-option position-relative" key={index}>
                                  {getDirectionText(option.side)}
                                </p>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div style={{textAlign:"start",fontSize:"12px"}}>
                        <span style={{textAlign:"start",fontSize:"12px"}}>{getDirectionText(trade.side)}</span>
                        </div>
                      )}
                    </td>
                    <td style={{ width: "400px", wordBreak: "break-all" }}>
                      {trade.blockChainId}
                      {isOpen(trade._id) && (
                        <div className="tableDropdownContent">
                          {trade.statsSnapshot?.orders?.map((option, index) => (
                            <p className="table-dropdown-option position-relative" key={index}>
                              {trade.blockChainId}
                            </p>
                          ))}
                        </div>
                      )}
                    </td>
                    <td style={{textAlign:"center"}}>
                      <a
                        href={trade.blockChainLink}
                        className="blockchainTradeLink"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
            
            {/* Desktop Pagination - Only show if there's more than one page */}
            
          </div>
          <div className="desktopOnly">
            {totalPages > 1 && (
              <div className="mt-2">
                <TablePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
          {/* Mobile View */}
          <div className="verifyBlockchainTradesMobileViewWrap d-md-none d-block">
            {paginatedTrades?.map((trade) => (
              <div key={trade._id} className="mobileTradeCard">
                <div className="tradeNameAndDurationWrap d-flex justify-content-between flex-wrap">
                  <div className="traderNameWrap d-flex align-items-center">
                    <div className="totalNumOfTrades">
                      <img alt="plusIcon" src={plusIcon} />
                      {trade.statsSnapshot?.orders?.length || 0}
                    </div>
                    <p
                      onClick={() => {
                        setSelectedTrade(trade);
                        setShow(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {trade.statsSnapshot?.name?.split("_")[0]}
                    </p>
                  </div>
                  <div className="dateAndTimeWrapper">
                    <p className="blockDate">{formatBackendDate(trade.createdAt)}</p>
                    <p>{formatTimeWithUTCOffset(trade.createdAt)}</p>
                  </div>
                </div>
                
                <div className="blockchainIdWrapper">
                  <h6>Blockchain Transaction ID</h6>
                  <p style={{ wordBreak: "break-all" }}>{trade.blockChainId}</p>
                </div>
                <div className="assetDirectionWrapper d-flex justify-content-between">
                  <div className="assetWrapper">
                    {/* <h6>Asset</h6> */}
                    <div
                      className="assertColumn"
                      onClick={() => handleSelectedDropdown(trade._id)}
                    >
                      <button className="tableDropdownButton">
                        <span className="selectedOption">
                          {
                            trade?.statsSnapshot?.orders?.length > 1
                              ? "Multiple Trades"
                              : trade?.statsSnapshot?.orders?.length === 1
                                ? (
                                  trade?.statsSnapshot?.orders[0]?.coinName?.includes("/")
                                    ? trade?.statsSnapshot?.orders[0]?.coinName
                                    : trade?.statsSnapshot?.orders[0]?.coinName?.replace(/(USDT|BUSD|USDC)$/, "/$1")
                                )
                                : trade?.type
                          }
                        </span>
                        <span className={`dropdownArrow ${isOpen(trade._id) && "rotate"}`}>
                          <img alt="dropdownAngle" src={dropdownAngle} />
                        </span>
                      </button>
                      {isOpen(trade._id) && (
                        <div className="tableDropdownContent">
                          {trade?.statsSnapshot?.orders?.map((option, index) => (
                            <p className="table-dropdown-option position-relative" key={index}>
                              {option.coinName?.includes("/")?option.coinName:option.coinName?.replace(/(USDT|BUSD|USDC)$/, "/$1")}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div className="directionWrapper">
                    <h6>Direction</h6>
                    <p>
                      {trade?.statsSnapshot?.orders?.length > 1
                        ? "Multiple"
                        : trade?.statsSnapshot?.orders?.length === 1
                        ? getDirectionText(trade.statsSnapshot?.orders[0]?.side)
                        : getDirectionText(trade.side)}
                    </p>
                  </div>
                </div>
                
                <div className="blockchainLinkWrapper">
                  <h6>Blockchain Link</h6>
                  <a
                    href={trade.blockChainLink}
                    className="blockchainTradeLink"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Transaction
                  </a>
                </div>
              </div>
            ))}

            {!trades?.length && !loading && (
              <div className="noDataMobileView">
                <img src={noDataIcon} alt="noDataIcon" />
                <h3 className="text-center">No verified trades yet</h3>
              </div>
            )}

            {/* Mobile Pagination - Only show if there's more than one page */}
            {totalPages > 1 && (
              <div className="mt-2">
                <TablePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      
      {show && selectedTrade && (
        <>
          {selectedTrade.tradeOf === "trader" ? (
            <DisplayModalForTrader
              displayName={name.split("_").join(" ")}
              showModal={show}
              setChangeShowModal={setShow}
              traderId={selectedTrade.refId}
            />
          ) : (
            <DisplayModalForCommunity
              communityName={selectedTrade.statsSnapshot?.name?.split("_")[0]}
              showModal={show}
              setChangeShowModal={setShow}
              userId={selectedTrade.refId}
            />
          )}
        </>
      )}
    </div>
  );
};

export default LeaderVerifedTrades;